export default "__VITE_ASSET__BWb72PeC__"